'use client';

import Link from 'next/link';

import { NavMdxDropdownItems } from '@/components/nav-mdx-menu';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { playSfx } from '@/hooks/use-sound';
import { cn } from '@/lib/utils';
import type { NavItem } from '@/types/nav';

export function MobileNav({
  items,
  className,
}: {
  items: NavItem[];
  className?: string;
}) {
  return (
    <DropdownMenu onOpenChange={(open) => playSfx(open ? 'open' : 'close')}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          data-sfx-managed=""
          className={cn(
            'group/toggle flex flex-col gap-1 data-[state=open]:bg-accent',
            className
          )}
          size="icon"
        >
          <span className="flex h-0.5 w-4 transform rounded-[1px] bg-foreground transition-transform group-data-[state=open]/toggle:translate-y-0.75 group-data-[state=open]/toggle:rotate-45" />
          <span className="flex h-0.5 w-4 transform rounded-[1px] bg-foreground transition-transform group-data-[state=open]/toggle:-translate-y-0.75 group-data-[state=open]/toggle:-rotate-45" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-64"
        align="end"
        sideOffset={8}
        data-sfx-managed=""
      >
        {items.map((link) => (
          <DropdownMenuItem key={link.href} asChild>
            <Link href={link.href}>{link.title}</Link>
          </DropdownMenuItem>
        ))}

        <DropdownMenuSeparator />

        <NavMdxDropdownItems />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
